<template>
  <ClubPostDelete
    :post="post"
    :club-slug="clubSlug"
    @success="closeAndRedirect"
    @delete="handleDelete" />
</template>

<script setup>
import ClubPostDelete from '@/components/Clubs/ClubPostDelete'

const props = defineProps({
  post: Object,
  clubSlug: String
})

const emit = defineEmits(['close', 'delete'])

const closeAndRedirect = () => {
  emit('close')
}

const handleDelete = (post) => {
  emit('delete', post)
}
</script>
